<wr-base-dialog status="danger"
                [header]="title"
                submitText="Löschen"
                (submit)="onDelete()"
                (close)="onCancel()">
  <p class="message">{{ message }}</p>

  @if (loading()) {
    <div class="impact-loading">
      <nb-spinner status="primary" size="small"></nb-spinner>
    </div>
  } @else if (hasImpact()) {
    <wr-banner [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
               status="warning"
               message="Dabei werden ebenfalls gelöscht:">
    </wr-banner>
    <ul class="impact-list">
      @if (impact()!.inspectionEntryCount > 0) {
        <li>
          <strong>{{ impact()!.inspectionEntryCount }}</strong>
          {{ impact()!.inspectionEntryCount | pluralize: 'Rundgangs-Eintrag' : 'Rundgangs-Einträge' }}
        </li>
      }
      @if (impact()!.buildingEquipmentCount > 0) {
        <li>
          <strong>{{ impact()!.buildingEquipmentCount }}</strong>
          {{ impact()!.buildingEquipmentCount | pluralize: 'TGA' : 'TGAs' }}
        </li>
      }
    </ul>
  }
</wr-base-dialog>
